package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebIcon
import com.merkost.handpass.sharedweb.components.Icon
import com.merkost.handpass.sharedweb.components.WebCard
import com.merkost.handpass.sharedweb.components.WebCardPadding
import com.merkost.handpass.sharedweb.theme.Accent
import com.merkost.handpass.sharedweb.theme.AccentSoft
import com.merkost.handpass.sharedweb.theme.WebType
import com.merkost.handpass.sharedweb.theme.Danger
import com.merkost.handpass.sharedweb.theme.OnSurface
import com.merkost.handpass.sharedweb.theme.OnSurfaceFaint
import com.merkost.handpass.sharedweb.theme.OnSurfaceMuted
import com.merkost.handpass.sharedweb.theme.Success
import com.merkost.handpass.sharedweb.theme.Warning
import com.merkost.handpass.sharedweb.theme.WarningSoft
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

enum class StatTrendDirection { Up, Down }

data class StatTrend(
    val text: String,
    val direction: StatTrendDirection,
    val suffix: String? = null,
)

@Composable
fun StatCard(
    label: String,
    value: String,
    icon: WebIcon? = null,
    onClick: (() -> Unit)? = null,
    highlight: Boolean = false,
    trend: StatTrend? = null,
) {
    val tileBg = if (highlight) WarningSoft.value() else AccentSoft.value()
    val tileFg = if (highlight) Warning.value() else Accent.value()
    val valueColor = if (highlight) Warning.value() else OnSurface.value()
    WebCard(onClick = onClick, padding = WebCardPadding.Comfortable) {
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                property("gap", "7px")
            }
        }) {
            if (icon != null) {
                Div(
                    attrs = Modifier
                        .backgroundColor(tileBg)
                        .borderRadius(8.px)
                        .color(tileFg)
                        .width(26.px)
                        .height(26.px)
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .justifyContent(JustifyContent.Center)
                        .toAttrs()
                ) {
                    Icon(icon, size = 15)
                }
            }
            Div({
                style {
                    fontSize(WebType.Label)
                    fontWeight(500)
                    property("color", OnSurfaceMuted.value().toString())
                }
            }) { Text(label) }
        }
        Div({
            style {
                fontSize(WebType.Stat)
                fontWeight(700)
                color(valueColor)
                property("font-variant-numeric", "tabular-nums")
                property("letter-spacing", "-0.02em")
                property("line-height", "1")
                property("margin-top", "14px")
            }
        }) { Text(value) }
        if (trend != null) {
            StatTrendLine(trend)
        }
    }
}

@Composable
private fun StatTrendLine(trend: StatTrend) {
    val arrow = if (trend.direction == StatTrendDirection.Up) "▲" else "▼"
    val trendColor = if (trend.direction == StatTrendDirection.Up) Success.value() else Danger.value()
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            property("gap", "4px")
            fontSize(WebType.Badge)
            fontWeight(600)
            property("margin-top", "8px")
            property("color", trendColor.toString())
        }
    }) {
        Text("$arrow ${trend.text}")
        trend.suffix?.let { suffix ->
            Span({
                style {
                    fontWeight(500)
                    property("color", OnSurfaceFaint.value().toString())
                }
            }) { Text(" $suffix") }
        }
    }
}
